// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"b8817620","305":"1104d2e1","480":"59c71a69","522":"2592604d","647":"e68eb557"}[chunkId] + ".chunk.css";
};